module.exports = __webpack_public_path__ + "img/enerman-etisol.1f757fa1.svg";